var activeFilters = [],
  divHolder = {},
  divVisible = {},
  timeout = null,
  running = {
    show: false,
    hide: false
  },
  changed = false;
$(".blog").on('click', '.tag', (e) => handleFilterChange(e));

$('.cl_grid-article-block').each((i, el) => {
  divHolder[i] = el;
  divVisible[i] = true;
});

activeFilters = $('.blog-filters .tag:has(> .active)').map((i, v) => {
  if($(v).data('id') == 'all') return;
  return $(v).data('id');
}).toArray();

var handleFilterChange = (e) => {
  e.preventDefault();
  $('.cl_grid').removeClass('empty');
  var target = e.target;
  if (e.target.className == 'tag-checkmark') target = e.target.parentNode;
  var filter = $(target).data('id');
  if (filter == 'all') {
    activeFilters = [];
  } else {
    if (activeFilters.indexOf(filter) == -1) {
      activeFilters.push(filter);
    } else {
      activeFilters.splice(activeFilters.indexOf(filter), 1);
    }
  }
  uiUpdateFilters(); // uiUpdateFilters
  clearTimeout(timeout);

  timeout = setTimeout(function () {
    uiUpdateView();
    console.log(activeFilters);
  }, 1000);
};

var uiUpdateFilters = () => {
  $('.blog .tag-checkmark').removeClass('active');
  if (activeFilters.length < 1) {
    // No filters 
    $('.blog .tag[data-id="all"] .tag-checkmark').addClass('active');
  } else {
    $.each(activeFilters, (i, v) => {
      $('.blog .tag[data-id="' + v + '"] .tag-checkmark').addClass('active');
    });
  }
};

/* uiUpdateView
 ** Updates the view with the new filters
 ** Break current loop?
 */
var isRunning = false;
var uiUpdateView = () => {
  if (!running.hide && !running.show) {
    isRunning = true;

    $.each(divHolder, (i, el) => {
      var index = $(el).data('id');
      var filters = $(el).data('filters').split(',');
      if ($(activeFilters).filter(filters).length > 0 || activeFilters.length == 0) {
        if (!divVisible[index]) divVisible[index] = true;
      } else {
        if (divVisible[index]) divVisible[index] = false;
      }
    });
    var hidden = [],
      shown = [];
    $.each(divVisible, (k, v) => {
      if (v) {
        shown.push(k);
      } else {
        hidden.push(k);
      }
    });
    stopChanges = {
      show: false,
      hide: false
    };
    doChanges(shown, 'show');
    doChanges(hidden, 'hide');

    isRunning = false;
    return;
  } else {
    // If we made it here, it means that this function was called too early and we probably changed the Filters
    stopChanges = {
      show: true,
      hide: true
    };
    setTimeout(function () {
      uiUpdateView();
    }, 1000);
  }
};

var stopChanges = {
  show: false,
  hide: false
};
var doChanges = (c, a) => {
  if (stopChanges[a]) {
    stopChanges[a] = false;
    running[a] = false;
    return;
  }
  running[a] = true;
  var delay = 100;
  if (a == 'hide') delay = 0;
  if (Object.keys(c).length > 0) {
    var key = c[0];
    setTimeout(function () {
      if (a == 'show') {
        attachDiv(key, divHolder[key]);
      } else {
        detachDiv(key);
      }
      c.shift();
      doChanges(c, a);
    }, delay);
  } else {
    running[a] = false;
    setTimeout(handleNoContent, 200);
  }
};

var handleNoContent = () => {
  if($('.cl_grid > div').length == 0) {
      $('.cl_grid').addClass('empty');
  }
};

var attachDiv = (i, el) => {
  if ($('.cl_grid-article-block[data-id="' + i + '"').length > 0) return;
  if ($('.cl_grid-article-block').eq(i).length < 1) {
    $('.cl_grid').append(el);
  } else {
    $('.cl_grid-article-block').eq(i).before(el);
  }
};
var detachDiv = (i) => {
  $('.cl_grid-article-block[data-id="' + i + '"').detach();
};

window.onload = (event) => {
  uiUpdateView();
};